/**
 * Paragraph Section Definition
 *
 * A body text content section.
 */

export const paragraphSection = {
  type: 'paragraph',
  label: 'Paragraph',
  icon: 'AlignLeft',
  description: 'Body text content',
  category: 'section',

  defaultContent: {
    text: 'Your response has been recorded successfully.',
    fontSize: '18',
    fontWeight: 'normal',
    textAlign: 'center',
    color: '#6b7280',
    sectionBackgroundColor: 'transparent',
    padding: { base: { top: 0, right: 0, bottom: 0, left: 0, unit: 'px' }, tablet: null, desktop: null },
    margin: { base: { top: 0, right: 0, bottom: 16, left: 0, unit: 'px' }, tablet: null, desktop: null },
  },

  settingsSchema: [
    // Content category
    {
      key: 'text',
      type: 'textarea',
      label: 'Text',
      category: 'Content',
      rows: 4,
      placeholder: 'Enter text content',
    },

    // Typography category
    {
      key: 'fontSize',
      type: 'number',
      label: 'Font Size (px)',
      category: 'Typography',
      min: 8,
      max: 120,
      default: '18',
    },
    {
      key: 'fontWeight',
      type: 'select',
      label: 'Font Weight',
      category: 'Typography',
      default: 'normal',
      options: [
        { value: 'normal', label: 'Normal' },
        { value: 'medium', label: 'Medium' },
        { value: 'semibold', label: 'Semibold' },
        { value: 'bold', label: 'Bold' },
      ],
    },
    {
      key: 'color',
      type: 'color',
      label: 'Text Color',
      category: 'Typography',
      default: '#6b7280',
    },

    // Style category
    {
      key: 'textAlign',
      type: 'select',
      label: 'Text Align',
      category: 'Style',
      default: 'center',
      options: [
        { value: 'left', label: 'Left' },
        { value: 'center', label: 'Center' },
        { value: 'right', label: 'Right' },
      ],
    },
    {
      key: 'sectionBackgroundColor',
      type: 'color',
      label: 'Background Color',
      category: 'Style',
      default: 'transparent',
      allowTransparent: true,
    },

    // Size category
    {
      key: 'width',
      type: 'responsiveDimension',
      label: 'Width',
      category: 'Size',
      default: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
    },
    {
      key: 'height',
      type: 'responsiveDimension',
      label: 'Height',
      category: 'Size',
      default: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
    },
    {
      key: 'minWidth',
      type: 'responsiveDimension',
      label: 'Min Width',
      category: 'Size',
      default: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
    },
    {
      key: 'minHeight',
      type: 'responsiveDimension',
      label: 'Min Height',
      category: 'Size',
      default: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
    },
    {
      key: 'maxWidth',
      type: 'responsiveDimension',
      label: 'Max Width',
      category: 'Size',
      default: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
    },
    {
      key: 'maxHeight',
      type: 'responsiveDimension',
      label: 'Max Height',
      category: 'Size',
      default: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
    },

    // Border category
    {
      key: 'sectionBorderWidth',
      type: 'number',
      label: 'Border Width',
      category: 'Border',
      min: 0,
      max: 20,
      default: 0,
    },
    {
      key: 'sectionBorderStyle',
      type: 'select',
      label: 'Border Style',
      category: 'Border',
      default: 'solid',
      options: [
        { value: 'solid', label: 'Solid' },
        { value: 'dashed', label: 'Dashed' },
        { value: 'dotted', label: 'Dotted' },
        { value: 'none', label: 'None' },
      ],
    },
    {
      key: 'sectionBorderColor',
      type: 'color',
      label: 'Border Color',
      category: 'Border',
      default: 'transparent',
    },
    {
      key: 'sectionBorderRadius',
      type: 'number',
      label: 'Border Radius',
      category: 'Border',
      min: 0,
      max: 100,
      default: 0,
    },

    // Spacing category
    {
      key: 'padding',
      type: 'responsivePadding',
      label: 'Padding',
      category: 'Spacing',
      default: { base: { top: 0, right: 0, bottom: 0, left: 0, unit: 'px' }, tablet: null, desktop: null },
    },
    {
      key: 'margin',
      type: 'responsiveMargin',
      label: 'Margin',
      category: 'Spacing',
      default: { base: { top: 0, right: 0, bottom: 16, left: 0, unit: 'px' }, tablet: null, desktop: null },
    },
  ],
};

export default paragraphSection;
